import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/(website)/global-footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/(website)/global-navbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/separator.tsx");
